export function formatCurrency(value) {
  return Number(value || 0).toLocaleString(undefined, {
    style: "currency",
    currency: "USD",
  });
}

export function formatDate(value) {
  if (!value) return "";

  return new Date(`${value}T00:00:00`).toLocaleDateString(undefined, {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
}

export function getLocationAddress(location) {
  if (!location) return "";

  if (location.address) {
    return location.address;
  }

  return [
    location.address_line1,
    location.address_line2,
    location.city,
    location.state,
    location.postal_code,
  ]
    .filter(Boolean)
    .join(", ");
}